import Backbone from 'backbone';
import Invoice from './invoice';

var InvoiceCollection = Backbone.Collection.extend({
  model: Invoice,
});

export default InvoiceCollection;
